<template>
  <div class="rt-select">
    <van-field
      v-model="result"
      v-bind="$attrs"
      readonly
      is-link
      @click="show = !show"
    />
    <van-popup v-model="show" position="bottom">
      <van-picker
        :item-height="$vanItemHeight"
        :columns="columns"
        show-toolbar
        :title="$attrs.label"
        value-key="categoryName"
        @cancel="show = !show"
        @confirm="onConfirm"
      />
    </van-popup>
  </div>
</template>

<script>
export default {
  model: {
    prop: "selectValue"
  },
  props: {
    columns: {
      type: Array
    },
    selectValue: {
      type: String
    }
  },
  data() {
    return {
      show: false,
      result: this.selectValue
    };
  },
  methods: {
    onConfirm(value) {
      this.result = value.categoryName;
      this.show = !this.show;
    }
  },
  watch: {
    selectValue: function(newVal) {
      // this.result = newVal;
    },
    result(newVal) {
      const columns = [...this.columns];
      console.log();
      columns.forEach(item => {
        if (newVal === item.categoryName) {
          this.$emit("input", item.categoryId + '');
        }
      })
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
